import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {setMoney, ID_PRECIO_SUGERIDO, ID_PRECIO_MAYORISTAS, ID_PRECIO_ESPECIAL} from "../../../utils/shared";
import {
  BanknotesIcon,
  CubeIcon,
  StarIcon, TicketIcon
} from '@heroicons/react/24/solid';

const iconStyle = {
  width: '1.20rem',
  height: '1.20rem',
  color: 'rgba(9,8,8,0.7)',
};

// Componente personalizado para mostrar íconos junto al texto
const CustomSingleValue = ({data}) => (
  <div>
    {data.amount}
  </div>
);

const CustomOption = (props) => {
  const {data, innerRef, innerProps, isFocused} = props;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className=""
      style={{
        backgroundColor: isFocused ? '#eee' : 'white',
        padding: '5px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        cursor: 'pointer'
      }}
    >
      {data.price_type === '1' && <TicketIcon style={iconStyle}/>}
      {data.price_type === ID_PRECIO_SUGERIDO && <BanknotesIcon style={iconStyle}/>}
      {data.price_type === ID_PRECIO_ESPECIAL && <StarIcon style={iconStyle}/>}
      {data.price_type === ID_PRECIO_MAYORISTAS && <CubeIcon style={iconStyle}/>}
      {setMoney(data.amount * 1)}
      <></>
    </div>
  );
};

// COMPONENTE PADRE
const SelectPriceComponent = ({setChangePrice, options, isDisabled}) => {
  const [amount, setAmount] = useState(false);
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    if(!amount){
      setAmount(true)
    }
  }, []);

  useEffect(() => {
    if(amount && options.length){
      setSelected(options[0])
    }
  }, [amount, options]);

  const handleChange = (selectedOption) => {
    setSelected(selectedOption)
    setChangePrice(selectedOption.price_type)
  };


  return (
    <div className="">
      <Select
        isSearchable={false}
        value={selected}
        isDisabled={isDisabled}
        getOptionValue={(option) => option.price_type}
        getOptionLabel={(option) => setMoney(option.amount * 1)}
        options={options}
        styles={colorStyles(false)}
        onChange={handleChange}
        components={{Option: CustomOption}}
        placeholder={'Precio'}
      />
    </div>
  );
};

const colorStyles = (hasError) => {
  return {
    indicatorSeparator: ()=> null,
    control: (baseStyles, state) => {
      return {
        ...baseStyles,
        backgroundColor: state.isDisabled ? '#eceff1' : '',
        borderRadius: 0,
        padding: "0px",
        borderWidth: state.isDisabled ? '0px' : '1px',
        borderColor: hasError && !state.isFocused ? 'red' : '#CFD8DC',
        fontSize: '12px',
        boxShadow: '0 !important',
        '&:hover': {
          border: hasError && !state.isFocused ? '1px solid red !important' : '1px solid #b0bec5 !important'
        },
        ':active': {
          ...baseStyles[':active'],
          borderColor: '#b0bec5'
        },
      }
    },
    option: (styles, {data, isDisabled, isFocused, isSelected}) => {
      return {
        ...styles,
        fontSize: "12px",
        color: '#2a2a2a',
        "backgroundColor": isSelected ? '#e2e8f0' : "rgba(255,255,255)",
        padding: "5px 10px",
        ':hover': {
          backgroundColor: '#f1f5f9',
          // color: '#94a3b8',
        },
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? '#CFD8DC'
              : '#CFD8DC'
            : undefined,
        },
      };
    },
    menu: (baseStyles, state) => {
      return {
        ...baseStyles,
        "backgroundColor": "rgba(253,253,253)",
        borderRadius: '0px',
        marginTop: '1px',
        padding: "5px 0 5px 0px",
      }
    },
    placeholder: (styles, state) => ({
      ...styles,
      fontSize: '0.84rem',
      fontWeight: '300',
      fontFamily: 'Roboto, sans-serif !important',
      color: '#2A2A2A',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: '#27292c',
      padding: "0px"
    }),
  }
};

export default SelectPriceComponent;